import { render, staticRenderFns } from "./SelectedProductsEdit.vue?vue&type=template&id=0b23a16a&scoped=true"
import script from "./SelectedProductsEdit.vue?vue&type=script&lang=js"
export * from "./SelectedProductsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b23a16a",
  null
  
)

export default component.exports